module.exports = __webpack_public_path__ + "img/lg_ring_r_i_1_0@2x.d4a5ac9a.png";